module.exports = __webpack_public_path__ + "img/A922.22d0447c.jpg";